



import { Vue, Component } from "vue-property-decorator";

import UserList from "@/components/userList.vue";

@Component({
  name: "AdminUser",
  components: {
    UserList,
  },
})
export default class AdminUser extends Vue {}
